import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import Cost from '@r1-frontend/ui-react/organisms/TariffSubscription/Cost';
import SubscriptionTitle from '@r1-frontend/ui-react/organisms/TariffSubscription/Title';
import { TSubscriptionTitleProps } from '@r1-frontend/ui-react/organisms/TariffSubscription/Title/Title';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TMainSubscriptionProps = {
    children: string,

    cost?: number,
    oldCost?: number,

    description?: string,
};

export type TBaseSubscriptionProps = TMainSubscriptionProps & TSubscriptionTitleProps

const BaseSubscription = ({
    children,
    description,
    cost,
    oldCost,

    Icon = InfoCircleFlip,
    iconSize = 16,
    onClick,

    ...props
}: TBaseSubscriptionProps): JSX.Element => {
    return <div {...props}>
        <SubscriptionTitle
            onClick={onClick}
            Icon={Icon}
            iconSize={iconSize}
        >
            {children}
        </SubscriptionTitle>

        {description && (
            <Paragraph4 $smaller dangerouslySetInnerHTML={{ __html: description }} $color={COLORS.TextInfo}/>
        )}

        {(cost && oldCost) && (
            <Cost oldCost={oldCost} currentCost={cost}/>
        )}
    </div>;
};

export default BaseSubscription;
